export enum InvoiceCalculatedStatus {
  DRAFT = 0,
  SENT = 1,
  RECEIVED = 2,
  SENT_OVERDUE = 3,
  PAID = 4,
  PARTIALLY_PAID = 5,
  PARTIALLY_PAID_OVERDUE = 6,
  VOID = 7,
  APPROVED = 8,
  APPROVED_OVERDUE = 9,
  REJECTED = 10,
  APPROVED_TO_SEND = 11,
  APPROVED_TO_SEND_OVERDUE = 12,
  APPROVAL_REQUESTED = 13,
  APPROVAL_REQUESTED_OVERDUE = 14,
  DISPUTED = 15,
  ON_HOLD = 16,
  PAYMENT_PROCESSING = 17,
  PAYMENT_PROCESSING_OVERDUE = 18,
  PAYMENT_PENDING = 19,
  PAYMENT_PENDING_OVERDUE = 20,
  SENT_FOR_REVIEW = 21,
  SENT_FOR_REVIEW_OVERDUE = 22,
  AWAITING_CONFIRMATION = 23,
  AWAITING_CONFIRMATION_OVERDUE = 24
}
